export type TeamFormResult="W"|"D"|"L";
type FormMatch={id:number;home:string;away:string;homeGoals:number;awayGoals:number;dateTs:number|null;round?:number};
export function buildTeamForm(teamNames:string[],matches:FormMatch[],orderKnown:boolean):Record<string,TeamFormResult[]>{
 const dated=(match:FormMatch)=>match.dateTs!==null&&Number.isFinite(match.dateTs);
 const selected=orderKnown?[...matches]:matches.filter(dated);
 const allDated=selected.every(dated);
 selected.sort((a,b)=>allDated?(a.dateTs!-b.dateTs!||a.id-b.id):((a.round??0)-(b.round??0)||a.id-b.id));
 const form:Record<string,TeamFormResult[]>={};for(const name of teamNames)form[name]=[];
 for(const match of selected){const home:TeamFormResult=match.homeGoals>match.awayGoals?"W":match.homeGoals<match.awayGoals?"L":"D";const away:TeamFormResult=home==="W"?"L":home==="L"?"W":"D";form[match.home]?.push(home);form[match.away]?.push(away);}
 for(const name of teamNames)form[name]=form[name].slice(-5);return form;
}
